import React from 'react';
import "./PageWrapper.css"

const PageWrapper = ({ children }) => <div className="page-wrapper">{children}</div>;

export default PageWrapper;
